import e from"./badge";export{StyledBadgeRoot,StyledBadge,StyledBadgePoints}from"./badge.styles";export default e;